// extracted by mini-css-extract-plugin
module.exports = {"card":"product-profile_card__gL3y1","profile":"product-profile_profile__paW0W"};